import storageAvailable from 'storage-available';

import { StorageAdapterInterface } from './types';

const isLSAvailable = () => storageAvailable('localStorage');

function hasKey(key: string): Promise<boolean> {
    if (!isLSAvailable()) {
        // throw new Error('local-storage not supported');
        return Promise.resolve(false);
    }

    const serializedItem = localStorage.getItem(key);
    return Promise.resolve(serializedItem != null);
}

function get<T = object>(key: string): Promise<T | undefined> {
    if (!isLSAvailable()) {
        // throw new Error('local-storage not supported');
        return Promise.resolve(undefined);
    }

    try {
        const deserializedItem = JSON.parse(localStorage.getItem(key)!);

        if (deserializedItem == null) {
            return Promise.resolve(undefined);
        }

        return Promise.resolve(deserializedItem);
    } catch (error) {
        throw new Error('local-storage deserialization failed');
    }
}

function set<T = object>(key: string, item: T): Promise<boolean> {
    if (!isLSAvailable()) {
        // throw new Error('local-storage not supported');
        return Promise.resolve(false);
    }

    try {
        const serializedItem = JSON.stringify(item);
        localStorage.setItem(key, serializedItem);

        return Promise.resolve(true);
    } catch (error) {
        throw new Error('local-storage serialization failed');
    }
}

function clear(): Promise<boolean> {
    if (!isLSAvailable()) {
        // throw new Error('local-storage not supported');
        return Promise.resolve(true);
    }

    try {
        localStorage.clear();
        return Promise.resolve(true);
    } catch (error) {
        throw new Error('local-storage clear failed');
    }
}

export default {
    hasKey,
    set,
    get,
    clear,
} as StorageAdapterInterface;
